<template>
    <div id="create-credit-memo" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title">Credit Memo Document</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="backToClaim">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content faq-crud">
                        <section class="internal-container border-top-table-fl">
                            <div class="row memo-header">
                                <div class="col-2">
                                    <img :src='logoPath' alt="Logo" style="max-height: 88px;">
                                </div>
                                <div class="col-2">
                                    <p class="m-0" style="font-size: 17px;"><b>Rizon Truck {{ region }}</b></p>
                                    <p class="m-0">{{ addressOne }}</p>
                                    <p class="m-0">{{ addressTwo }}</p>
                                </div>
                                <div class="col-4">
                                    <table class="table table-borderless">
                                        <tbody>
                                            <tr>
                                                <td class="control-label" style="font-size: 17px;">
                                                    <b>CUSTOMER</b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><b>Dealer Name:</b></td>
                                                <td>{{ dealerName }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Address:</b></td>
                                                <td>{{ dealerAddress }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>City, State, Zip:</b></td>
                                                <td>{{ dealerCityStateZip }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Dealer Code:</b></td>
                                                <td>{{ dealerCode }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>BillCusId:</b></td>
                                                <td>{{ billCusId }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-3">
                                    <table class="table table-borderless">
                                        <tbody>
                                            <tr>
                                                <td><b>Credit Memo#:</b></td>
                                                <td>{{ creditMemoNumber }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Date:</b></td>
                                                <td>{{ date }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Amount:</b></td>
                                                <td>${{ totalPaid }}</td>
                                            </tr>
                                            <tr>
                                                <td><b>Credit Memo Issued By:</b></td>
                                                <td>{{ memoIssuedBy }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-1 text-right pl-0">
                                    <img :src='flagPath' alt="Flag" style="max-height: 68px;">
                                </div>
                            </div>
                            <div class="mt-4" style="width: 40%;">
                                <table class="table table-bordered custom-table" style="border-collapse: collapse;">
                                    <tr>
                                        <td class="text-center">
                                            <b>VIN</b>
                                        </td>
                                        <td>{{ vin }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="mt-2">
                                <table class="table table-bordered custom-table"
                                    style="border-collapse: collapse; width: 100%;">
                                    <thead>
                                        <tr class="text-center">
                                            <th>Claim #</th>
                                            <th>Repair Order</th>
                                            <th>Claimed Amt</th>
                                            <th>Labor Paid</th>
                                            <th>Parts Paid</th>
                                            <th>Other Paid</th>
                                            <th>Tax Paid</th>
                                            <th>Total Paid</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="text-center align-middle">
                                            <td class="align-middle" style="width: 12.5%;">{{ claimNumber }}</td>
                                            <td class="align-middle" style="width: 12.5%;">{{ repairOrder }}</td>
                                            <td class="align-middle" style="width: 12.5%;">${{ claimedAmount }}</td>
                                            <td class="align-middle" style="width: 12.5%;">${{ laborPaid }}</td>
                                            <td class="align-middle" style="width: 12.5%;">${{ partPaid }}</td>
                                            <td class="align-middle" style="width: 12.5%;">${{ otherPaid }}</td>
                                            <td class="align-middle" style="width: 12.5%;">
                                                <input type="text" @keypress="filterNumericValue" class="form-control"
                                                    v-model="taxPaid" style="width: 100%;" @focus="taxPaidFocused"
                                                    @blur="taxPaidBlured" @click="taxPaidMoveCursorToEnd" />
                                            </td>
                                            <td class="align-middle" style="width: 12.5%;">${{ totalPaid }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p class="text-center mt-5">
                                <b>
                                    For Questions Please Contact The Warranty Department <a
                                        href="mailto:rizonwarranty@rizontruck.us">rizonwarranty@rizontruck.us</a>
                                </b>
                            </p>
                            <div class="row align-items-center d-flex justify-content-start mt-5">
                                <div class="col-12 form-group">
                                    <div class="d-flex justify-content-between">
                                        <label class="control-label" for="comment">Comment</label>
                                        <span style="font-size: 14px;">{{ commentCount }}/250</span>
                                    </div>
                                    <textarea style="resize: none;" class="form-control" v-model="comment" id="comment"
                                        rows="5" maxlength="250" placeholder="Write Comment..."></textarea>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <button type="button" @click="submitCreditMemo"
                                    style="height: 35px;width: 80px;font-weight: bold;" class="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                            <div class="mt-4">
                                <p class="mr-5 mb-0">
                                    <b>
                                        For Claim Details Please Review Claims In DealerPro Warranty Claims Management
                                        System
                                    </b>
                                </p>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === 'already-created'">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            409 </h2>
                        <div class="error-details">
                            Sorry!, Credit memo for this claim has already been created.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import { commonMixins } from '../mixins/commonMixins';
import moment from 'moment';

export default {
    name: "CreateCreditMemo",
    metaInfo() {
        return { title: "Create Credit Memo | " + process.env.COPYRIGHT_NAME }
    },
    mixins: [commonMixins],
    data: () => ({
        permissions: [],
        loading: false,
        cantAccessPage: '',
        claimId: 0,
        logoPath: '',
        addressOne: '',
        addressTwo: '',
        region: process.env.REGION,
        flagPath: '',
        dealerName: '',
        dealerAddress: '',
        dealerCityStateZip: '',
        dealerCode: '',
        billCusId: '',
        comment: '',
        commentCount: 0,
        vin: '',
        claimNumber: '',
        repairOrder: '',
        claimedAmount: '',
        laborPaid: '',
        partPaid: '',
        otherPaid: '',
        taxPaid: '$0',
        totalPaid: '',
        creditMemoNumber: '',
        date: '',
        memoIssuedBy: '',
        userObj: '',
        bypassConfirmation: false
    }),
    beforeRouteLeave(to, from, next) {
        if (this.bypassConfirmation) {
            next();
        } else {
            if (confirm("You have unsaved changes. Are you sure you want to leave?")) {
                next(); // Proceed with navigation
            } else {
                next(false); // Cancel navigation
            }
        }
    },
    created: function () {
        this.logoPath = process.env.LOGO_PATH;
        this.flagPath = process.env.FULL_FLAG_LOGO_PATH;
        this.addressOne = process.env.HQ_ADDRESS_ONE;
        this.addressTwo = process.env.HQ_ADDRESS_TWO;
        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
    watch: {
        permissions: function (permission) {
            var self = this;
            permission.forEach(function (permissions) {
                if (permissions.name == 'ev_view_all_form_fields') {
                    self.cantAccessPage = true;
                }
            });
        },
        comment(value) {
            if (value.length > 250) {
                this.comment = value.substring(0, 250);
            }
            this.commentCount = value.length;
        },
        taxPaid(value) {
            if (value.charAt(0) !== '$') {
                this.taxPaid = '$' + value;
            }
        }
    },
    mounted: function () {
        var self = this;
        self.getPermissions();
        self.claimId = this.$route.params.id;
        self.userObj = JSON.parse(localStorage.getItem("user_obj"));
        self.getClaimById();
        self.generateCreditMemoNumber();
    },
    methods: {
        beforeWindowUnload(event) {
            if (this.bypassConfirmation) {
                event.preventDefault();
                event.returnValue = '';
            }
        },
        backToClaim() {
            this.$router.push({
                name: 'WarrantyClaimEdit',
                params: { id: this.claimId }
            });
        },
        taxPaidFocused() {
            if (this.taxPaid == '$0') {
                this.taxPaid = '$';
            }
        },
        taxPaidBlured() {
            if (this.taxPaid == '$') {
                this.taxPaid = '$0';
            }
        },
        taxPaidMoveCursorToEnd(event) {
            const input = event.target;
            input.setSelectionRange(input.value.length, input.value.length);
        },
        submitCreditMemo() {
            var self = this;

            var formData = new FormData();
            formData.append('claim_id', self.claimId);
            formData.append('credit_memo_number', self.creditMemoNumber);
            formData.append('credit_memo_date', self.date);
            formData.append('credit_memo_issued_by', self.userObj.id);
            formData.append('credit_memo_comment', self.comment);
            if (self.taxPaid.charAt(0) === '$') {
                formData.append('credit_memo_tax_paid', self.taxPaid.substring(1));
            } else {
                formData.append('credit_memo_tax_paid', self.taxPaid);
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/create-credit-memo",
                type: "POST",
                headers: self.ajxHeaders,
                data: formData,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: (data) => {
                    self.loading = false;
                    if (data.code == 200) {
                        self.bypassConfirmation = true;
                        self.$router.push({
                            name: 'WarrantyClaimEdit',
                            params: { id: self.claimId }
                        });
                    }
                },
                error: (jqXHR, exception) => {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'submit-credit-memo');
                }
            });
        },
        generateCreditMemoNumber() {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/warranty-claim/generate-credit-memo-number/" + self.claimId,
                type: "GET",
                headers: self.ajxHeaders,
                dataType: "json",
                success: (data) => {
                    self.loading = false;
                    if (data.code == 200) {
                        self.creditMemoNumber = data.content;
                        self.date = moment().format("MM/DD/YYYY");
                        self.memoIssuedBy = self.userObj.username || self.userObj.email;
                    }
                },
                error: (jqXHR, exception) => {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, false, 'generate-credit-memo-number');
                }
            });
        },
        getClaimById() {
            var self = this;

            self.loading = true;
            if (self.claimId) {
                $.ajax({
                    url: process.env.ROOT_API + "/warranty-claim/view/" + self.claimId,
                    type: "GET",
                    headers: self.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.code == 200) {
                            var claim = data.content;

                            self.dealerName = (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.name) || '';
                            self.dealerAddress = (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.address_line_1) || '';
                            self.dealerCityStateZip = (
                                (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.city && claim.ev_claim_header.dealer.city.name || '')
                                + ',' +
                                (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.state && claim.ev_claim_header.dealer.state.name || '')
                                + ',' +
                                (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.postcode || '')
                            );
                            self.dealerCode = (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.code) || '';
                            self.billCusId = (claim.ev_claim_header.dealer && claim.ev_claim_header.dealer.parent && claim.ev_claim_header.dealer.parent.code) || '';

                            self.vin = claim.ev_claim_header.vehicle && claim.ev_claim_header.vehicle.vin || '';
                            self.claimNumber = claim.claim_number || '';
                            self.repairOrder = claim.ev_claim_header.dealer_ro_number || '';
                            self.claimedAmount =
                                (claim.ev_summary && claim.ev_summary.total_requested_amount !== undefined)
                                    ? claim.ev_summary.total_requested_amount
                                    : 0;
                            self.laborPaid =
                                (claim.ev_summary && claim.ev_summary.total_labor_approved_amount !== undefined)
                                    ? claim.ev_summary.total_labor_approved_amount
                                    : 0;
                            self.partPaid =
                                (claim.ev_summary && claim.ev_summary.total_part_approved_amount !== undefined)
                                    ? claim.ev_summary.total_part_approved_amount
                                    : 0;
                            self.otherPaid =
                                (claim.ev_summary && claim.ev_summary.total_other_charges_approved_amount !== undefined)
                                    ? claim.ev_summary.total_other_charges_approved_amount
                                    : 0;
                            self.totalPaid =
                                (claim.ev_summary && claim.ev_summary.total_approved_amount !== undefined)
                                    ? claim.ev_summary.total_approved_amount
                                    : 0;

                            // Check if all required credit memo fields have values
                            if (
                                data.content.ev_claim_header.credit_memo_issued_by &&
                                data.content.ev_claim_header.credit_memo_pdf_path &&
                                data.content.ev_claim_header.credit_memo_date &&
                                data.content.ev_claim_header.credit_memo_number
                            ) {
                                // If all fields have values, show credit memo already created
                                self.cantAccessPage = 'already-created';
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR, false, 'get-claim-by-id')
                    }
                });
            }
        }
    }
};
</script>
<style scoped>
.memo-header td {
    padding: 0;
}

.memo-header tr td:first-child {
    width: 120px;
}

.custom-table,
.custom-table th,
.custom-table td {
    border: 1px solid black !important;
    padding: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateCreditMemo.vue